// tslint:disable no-import-side-effect ordered-imports
import styles from './app.module.scss';
import React, { useEffect, useState } from 'react';

import {
  Button,
  LoadingSpinner,
  Popover,
  PopoverTrigger,
  IPopoverProps,
  PopoverContent
} from '@opengov/component-library';

import { FEDERATED_SERVICEIDS_TYPE } from './types';
import { useAppSwitcherStore } from './store/useAppSwitcherStore';

import { AppSwitcherPopoverContent } from './AppSwitcherPopover/AppSwitcherPopoverContent';

import { AppSwitcherPopoverTrigger } from './AppSwitcherPopover/AppSwitcherPopoverTrigger';
import { IAuth0Config } from './auth0CredentialsProvider/auth0CredentialProvider';
interface IAppSwitcherProps {
  activeProduct?: string;
  baseUrl: string;
  federatedId: string;
  placement?: IPopoverProps['placement'];
  auth0Config?: IAuth0Config;
}

const AppSwitcherPopover = (props: IAppSwitcherProps) => {
  const { activeProduct: activeProduct, federatedId, placement, baseUrl, auth0Config } = props;
  const [urlsLoading, setUrlsLoading] = useState(true);
  const getEntityAndProducts = useAppSwitcherStore((state) => state.getEntityAndProducts);

  let federatedServiceIdType: FEDERATED_SERVICEIDS_TYPE = 'BY_FRIENDLY_ID';
  switch (activeProduct?.toLowerCase()) {
    case 'financial':
      federatedServiceIdType = 'BY_FINANCIALS_CUSTOMER_ID';
      break;
    case 'cit':
      federatedServiceIdType = 'BY_CIT_COMMUNITY_ID';
      break;
    case 'oth':
      federatedServiceIdType = 'BY_OTH_PORTAL_ID';
      break;
    case 'od':
      federatedServiceIdType = 'BY_CKAN_CUSTOMER_ID';
      break;
    case 'procurement':
      federatedServiceIdType = 'BY_PROCUREMENT_ID';
      break;
    case 'eam':
      federatedServiceIdType = 'BY_ASSET_MANAGEMENT_ID';
      break;
    default:
      federatedServiceIdType = 'BY_FRIENDLY_ID';
  }

  useEffect(() => {
    getEntityAndProducts(federatedServiceIdType, federatedId, baseUrl, auth0Config)
      .then(() => setUrlsLoading(false))
      .catch((e) => setUrlsLoading(false));
  }, [federatedServiceIdType, federatedId, baseUrl]);

  const products = useAppSwitcherStore((state) => state.products);
  return (
    <Popover placement={placement} id="opengov-app-switcher" closeOnBlur={true} returnFocusOnClose={false}>
      <PopoverTrigger>
        <Button variant="naked" data-test="switcher-grid" className={styles.wrapper}>
          <AppSwitcherPopoverTrigger />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={styles.content}>
        {urlsLoading ? (
          <LoadingSpinner className={styles.loader}>Loading...</LoadingSpinner>
        ) : (
          <AppSwitcherPopoverContent activeProduct={activeProduct} products={products} />
        )}
      </PopoverContent>
    </Popover>
  );
};
export const AppSwitcher: React.FunctionComponent<IAppSwitcherProps> = ({
  activeProduct: activeProduct = 'RNT',
  baseUrl,
  federatedId,
  placement,
  auth0Config
}) => {
  return (
    <AppSwitcherPopover
      activeProduct={activeProduct}
      placement={placement || 'auto-end'}
      baseUrl={baseUrl || ''}
      federatedId={federatedId}
      auth0Config={auth0Config}
    />
  );
};
